import _plugin_vue_export_helper_default from "../../../../_virtual/_plugin-vue_export-helper.js";
import AddressBarHistory_vue_vue_type_script_setup_true_lang_default from "./AddressBarHistory.vue.script.js";
/* empty css                                */
//#region src/v2/blocks/scalar-address-bar-block/components/AddressBarHistory.vue
var AddressBarHistory_default = /*#__PURE__*/ _plugin_vue_export_helper_default(AddressBarHistory_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-a54819b1"]]);
//#endregion
export { AddressBarHistory_default as default };

//# sourceMappingURL=AddressBarHistory.vue.js.map